/**
 * External dependencies
 */
import styled from '@emotion/styled';
/**
 * Internal dependencies
 */
import { FlexItem } from '../../flex';

export const SelectWrapper = styled( FlexItem )`
	width: 110px;
`;
